import React, { useEffect, useState } from "react";
import "./styles.scss";
import { GetBaseUrl } from "../modules/getBaseUrl";

import Checkbox from "@mui/material/Checkbox";
import Button from "../modules/Button";
import tick from "../../Assets/svg/green-bg-tick.svg";
import ModalComponent from "../modules/Modal";
import doc from "../../Assets/svg/doc icon.svg";

import { useNavigate } from "react-router-dom";
import TermsForMentor from "../PreAwarded/TermsForMentor";
import { api } from "../../Services";
import { useDispatch, useSelector } from "react-redux";
import { resetState } from "../PersonalInfo/redux/actions";
import { resetIncome } from "../IncomeDetails/redux/actions";
import { resetEdu } from "../Education/redux/actions";
import { resetRegister } from "../Register/redux/actions";
import { resetApp } from "../ApplicationForm/redux/actions";
import { resetQueries } from "../Queries/redux/actions";
import { resetStatus } from "../WelcomeBack/redux/actions";
import { clearDisburse } from "../DisburseForm/redux/actions";
import { resetClear } from "../Connect/redux/actions";
import { doLogout } from "../LoginPage/redux/actions";


const label = { inputProps: { "aria-label": "Checkbox demo" } };

function AlumniScreen() {
  const dispatch = useDispatch();

  const [link, setLink] = useState("");
  const navigate = useNavigate();
  const [btn, setBtn] = useState(true);
  const personalInfo = useSelector((state) => state.personal.personalInfo);

  const tokenData = useSelector((state) => state.tokens.tokens);
  const [box, setBox] = useState(false);
  const [ModalData, setModalData] = useState({
    show: false,
    type: "confirm",
    title: "Connection Request",
    countDown: " ",
    desc: "",
  });
  console.log("in alumni");
  const mentorContent = () => {
    return (
      <div className="feedback-content">
        <div className="cred-btn">
          <Button
            onClickHandler={() => setModalData({ ...ModalData, show: false })}
            value={"Agree! Decline"}
            type={"outlined"}
          />
          <Button
            onClickHandler={() => navigate("/application/alumni/connect")}
            // disabled={
            //   type === "mobile"
            //     ? mobile.number.length !== 10
            //     : mobile.otp === "000000" || mobile.otp.length !== 6
            // }
            // disabled={feedback?.options?.length === 0}
            // value={type === "mobile" ? "Send OTP" : "Sign in"}
            value={"No, Accept"}
            type={"contained"}
          />
        </div>
      </div>
    );
  };
  const getLogout = async () => {
    // const personalInfo = useSelector((state) => state.personal.personalInfo);
    // const dispatch = useDispatch();
    // const tokenData = useSelector((state) => state.tokens.tokens);

    try {
      let users = await api.logout(tokenData.token, personalInfo?.mobile);
      console.log('logout api', users)
      // if (users.statusCode == 200) {
        dispatch(resetState());
        dispatch(resetIncome());
        dispatch(resetEdu());
        dispatch(resetRegister());
        dispatch(resetApp());
        dispatch(resetQueries());
        dispatch(resetStatus());
        dispatch(clearDisburse());
        dispatch(resetClear());
        dispatch(doLogout());
      // }
      // return users;
    } catch (error) {
      console.error("Error logging out:", error);

      //   } finally {
      // setIsLoading(false);
    }
  };
  const logoutMsg = async () => {
    let users = await getLogout();
    console.log("logout api", users);
    console.log("u have been logged out");
  };
  const setTAC = async (data) => {
    try {
      const tacData = await api.setTAC(tokenData.token, tokenData.appId);

      console.log("tac data 1", tacData);
      if (
        tacData.statusCode !== 200 &&
        tacData.data.includes("Session expired")
      ) {
        logoutMsg();
      }
      return tacData;
    } catch (err) {
      console.log("err in tac", err);
      if (err?.statusCode !== 200 && err?.data?.includes("Session expired")) {
        logoutMsg();
      }
    }
  };

  const takeAwarded = async () => {
    // setTAC();
    try {
      const tacData = await setTAC();
      if (tacData?.statusCode == 200) {
        navigate("/application/alumni/connect");
      }
      // return users;
      console.log("tac data 2", tacData);
    } catch (err) {
      console.log("err in tac", err);
      navigate("/application/alumni/connect");
    }
  };
  useEffect(() => {
    let url = GetBaseUrl(window.location.href);
    setLink(url);
  }, []);
  return (
    <div className="form-div alumni-page">
      <div className="progress-title form-title"> Welcome,</div>
      <div style={{ color: "#637083" }} className="sub-option-text">
        Welcome to our networking platform where you can explore a lineup of
        scholars to connect with, opportunities for knowledge sharing and
        upskilling.
      </div>
      <div className="terms-section">
        <div className="md-title">
          <img style={{ marginRight: "2%" }} src={doc} alt="doc" />
          Terms and Conditions
        </div>
        <TermsForMentor checkBtn={(e) => setBtn(e)} />
        <div className="btn-set">
          <Button
            onClickHandler={() => {}}
            type={"override-bg"}
            value={"Decline"}
          />
          <Button
            disabled={btn}
            onClickHandler={() => takeAwarded()}
            type={"contained "}
            value={"Accept"}
          />
        </div>
      </div>
    </div>
  );
}

export default AlumniScreen;
